import React from 'react'

const Quizlist = () => {
  return (
    <div>Quizlist</div>
  )
}

export default Quizlist